import { PropsWithChildren, createContext, useMemo, useState } from 'react';

export interface OrderContextType {
  onBookAndPay?: () => boolean;
  setOnBookAndPay: (cb: (() => boolean) | undefined) => void;
}

export const OrderContext = createContext<OrderContextType>({ onBookAndPay: undefined, setOnBookAndPay: () => {} });

export const OrderContextProvider = ({ children }: PropsWithChildren) => {
  const [onBookAndPay, setOnBookAndPay] = useState<(() => boolean) | undefined>(undefined);
  const value = useMemo<OrderContextType>(() => ({ onBookAndPay, setOnBookAndPay: (cb) => setOnBookAndPay(() => cb) }), [onBookAndPay, setOnBookAndPay]);

  return <OrderContext.Provider value={value}>{children}</OrderContext.Provider>;
};
